import {getThreatScore} from "../../service/dashboard";

const auth = {
  namespaced: true,
  state: {
    count_req_num: 0,
    count_res_num: 0,
    axiosPromiseCancel: [], //接口请求存放数组
    start_time: "",
    end_time: "",
    status: 0, // 隐私模式状态
    industry_val: "",
    token: ""
  },
  mutations: {
    /**
         * 请求依次存放数组中
         * @param state
         * @param data
         */
    setToken(state, data) {
      state.token = data;
    },
    setAxiosPromiseCancel(state, data) {
      state.axiosPromiseCancel.push(data);
    },
    add_req_num(state) {
      state.count_req_num += 1;
    },
    add_res_num(state) {
      state.count_res_num += 1;
    },
    reset_req_num(state) {
      state.count_req_num = 0;
    },
    reset_res_num(state) {
      state.count_res_num = 0;
    },
    privacy_status(state, data) {
      state.status = data;
    },
    record_time(state, data) {
      // eslint-disable-next-line camelcase
      let [start_time, end_time] = data;

      // eslint-disable-next-line camelcase
      state.start_time = start_time;
      // eslint-disable-next-line camelcase
      state.end_time = end_time;
    },
    industry(state, data) {
      state.industry_val = data;
    },
    /**
         * 取消数组中的所有请求,并重置数组
         * @param state
         */
    clearAxiosPromiseCancel(state) {
      // 路由跳转, 取消上个路由页面所有请求(如果还在pending状态的会直接变成canceled状态)
      if (state && state.axiosPromiseCancel.length > 0) {
        state.axiosPromiseCancel.forEach(e => {
          e && e.f();
        });
        state.axiosPromiseCancel = [];
      }
    },
    /**
         * 取消当前数组中重复请求
         * @param state
         * @param index
         */
    clearCommonAxiosPromiseCancel(state, index) {
      state.axiosPromiseCancel[index].f(); //重复请求执行取消操作
      state.axiosPromiseCancel.splice(index, 1); //把这条记录从数组中移除
    }
  }
};

export default auth;
